import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { Tabel } from 'src/app/interfaces/auth.interface';
import { UsersService } from 'src/app/services/panels/users.service';
import { AngularFirestore } from '@angular/fire/firestore';
import { Router } from '@angular/router';
import { AdminAccessService } from 'src/app/services/admin-access.service';
import { Access } from 'src/app/interfaces/access';
import { AuthService } from 'src/app/services/auth.service';

@Component({
  selector: 'app-view-users',
  templateUrl: './view-users.component.html',
  styleUrls: ['./view-users.component.scss']
})
export class ViewUsersComponent implements OnInit,OnDestroy {

  users: Tabel[] =[]

  access:Access[]=[]
  userObservable:Subscription;

  constructor(private user:UsersService,
    private fs: AngularFirestore,
    private getaccess:AdminAccessService,
    private router:Router,
    private auth: AuthService) { }

  ngOnInit(): void {
    this.userObservable = this.user.getUsers().subscribe(data => {
      this.users = data.map(element => {
        return {
          id:element.payload.doc.id,
          ...element.payload.doc.data() as {},
        }
      })
    })

    this.getaccess.getAccess().subscribe(data=> {
      this.access = data.map(element => {
        return {
          id:element.payload.doc.id,
          ...element.payload.doc.data() as {},
        }
      })
    })

  }
  deleteUser(id:string) {
    this.fs.doc(`users/${id}`).delete()
    .then(()=> {
      alert('deleted')
    })
  }

  ngOnDestroy() {
    this.userObservable.unsubscribe();
  }

  deleteAccess(){
    // this.fs.doc(`admins/${id}`).delete()
    this.auth.logout().then(()=>{
        this.router.navigate(['/controls-panel-login'])
    })
  }

}
